(() => {
  if (customElements.get('rdb-opening')) return;
  customElements.define('rdb-opening', class extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('rdb-opening--screen')) return;
      this.header = document.getElementById('header-group');
      if (!this.header) return;
      this.observer?.disconnect();
      this.observer = new ResizeObserver(() => this.measureHeader());
      this.observeSections();
      this.mutations?.disconnect();
      this.mutations = new MutationObserver(() => this.observeSections());
      this.mutations.observe(this.header, { childList: true });
    }

    observeSections() {
      this.observer.disconnect();
      this.sections = [...this.header.children].filter((element) => element instanceof HTMLElement);
      this.sections.forEach((section) => this.observer.observe(section));
      this.measureHeader();
    }

    measureHeader() {
      const height = Math.ceil(this.sections.reduce((total, section) => total + section.getBoundingClientRect().height, 0));
      this.style.setProperty('--opening-header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mutations?.disconnect();
    }
  });
})();
